module.exports = __webpack_public_path__ + "img/team-photo.5d2c0412.webp";